import cn from 'classnames/bind'
import styles from './index.module.sass'
import React, { ReactNode } from 'react'

const cx = cn.bind(styles)

export interface TypeOfTransactionProps {
    theme?:
        | 'Token_transfer'
        | 'Contract_call'
        | 'Transaction'
        | 'Coin_transfer'
        | string
    children: ReactNode
}

export const TypeOfTransaction = ({
    theme = 'Transaction',
    children,
}: TypeOfTransactionProps) => {
    return (
        <div>
            {children}
        </div>
    )
}